import { pollInstance } from '@/axios';
/* eslint-disable no-param-reassign */

const levelTypeModule = {
	actions: {
		async create({ dispatch }, { toolCode, ...rest }) {
			const url = 'tools-type';
			await pollInstance.post(url, rest);
			dispatch('load', toolCode);
		},
		async load({ commit }, toolCode) {
			const url = `tools-type/${toolCode}`;
			const { data: levels } = await pollInstance.get(url);
			commit('SET_LEVELS_BY_TOOL', levels);
		},
	},
	getters: {
		levels(state) {
			return [].concat({ name: 'Nuevo tipo' }, state.list);
		},
	},
	mutations: {
		SET_LEVELS_BY_TOOL(state, levels) {
			state.list = levels;
		},
	},
	state: {
		list: [],
	},
};

export default levelTypeModule;



// WEBPACK FOOTER //
// ./src/store/modules/levelType/index.js